import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@Components/Button';
import Tooltip from '@Components/Tooltip';
import { closeButtonId } from './InfoTooltipOnClickConstants';

export default class InfoTooltipOnClickTrigger extends React.PureComponent {
  componentDidMount() {
    Tooltip.rebuild();
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const { dataFor, e2eName, className, contentClassName, children, informationIconTitle, ariaLabel, ...otherProps } = this.props;

    return (
      <Button
        buttonConfig={{
          type: 'link',
          className: 'info-tooltip',
          size: 'lg',
          aTag: true,
          noBorder: true,
          iconOnly: true,
          ariaLabel,
          e2eName,
        }}
        iconConfig={{
          name: 'information-notitle',
          size: 'sm',
          noBorder: true,
          title: informationIconTitle,
          className,
        }}
        data-for={dataFor}
        data-tip={ReactDOMServer.renderToString(
          <div className={classnames(['info-tooltip-content-wrapper', 'on-click', contentClassName])}>
            <Button
              id={closeButtonId}
              buttonConfig={{
                type: 'link',
                className: 'info-tooltip-close-btn',
                size: 'xs',
                ariaLabel: 'Close tooltip',
                iconOnly: true,
                e2eName: 'e2e-alert-create-dialog-tooltip-close',
              }}
              iconConfig={{
                name: 'delete-notitle',
                size: 'xs',
                title: 'Close tooltip',
              }}
            />
            <div className="info-tooltip-content-">{children}</div>
          </div>
        )}
        data-event="click"
        {...otherProps}
      />
    );
  }
}

InfoTooltipOnClickTrigger.propTypes = {
  dataFor: PropTypes.string.isRequired,
  e2eName: PropTypes.string.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  informationIconTitle: PropTypes.string,
  ariaLabel: PropTypes.string,
};
